<script setup lang="ts">
import { watch, ref } from 'vue';
import Button from 'primevue/button';
import ExportExcelFile from '@/components/modal/utils/ExportExcelFile.vue';

interface Props {
  type?: string;
  dataExport?: any;
  sheetColumnStyle?: any;
  fileName?: string;
}
const props = defineProps<Props>();

const emits = defineEmits<{
  applyImport: [];
  handleClose: [];
  applyRevert: [];
}>();

const sheetsData = ref<any>([]);

const handleImportFile = () => {
  emits('applyImport');
};

const handleRevertFile = () => {
  emits('applyRevert');
};

const closeModal = () => {
  emits('handleClose');
};

watch(
  () => props.dataExport,
  (newVal: any) => {
    sheetsData.value = [
      {
        name: 'Sheet 1',
        data: newVal
      }
    ];
  },
  { deep: true }
);
</script>
<template>
  <div>
    <div class="flex">
      <div class="w-full text-center" v-if="type === 'IMPORT'">
        <Button id="btn-import-file" icon="pi pi-plus" @click="handleImportFile()" :label="$t('common.buttons.import_file_now')" class="import-button ml-4" />
      </div>
      <div class="w-full text-center" v-if="type === 'REVERT'">
        <Button id="btn-revert-file" icon="pi pi-plus" @click="handleRevertFile()" :label="$t('common.labels.revert_to_this_version')" class="revert-button ml-4" />
      </div>
      <div class="w-full text-center" v-if="type === 'EXPORT'">
        <ExportExcelFile id="btn-export-file" class="export ml-4" :sheets="sheetsData" :columnsStyle="sheetColumnStyle" :file-name="fileName"></ExportExcelFile>
      </div>
      <div :class="['text-center close-btn-wrapper', { 'w-full': type === 'PREVIEW' }]">
        <Button id="btn-close" @click="closeModal()" :label="$t('common.buttons.close')" />
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.custom-button {
  background-color: $col-primary;
  color: $col-white;
  font-family: $font-med19;
  font-weight: normal;
}
</style>
